import ComponentWithSocket from '../../../lib/component';
import {Component} from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/ro';
moment.locale('ro');

@Component
export default class CertificatesManage extends ComponentWithSocket {
    public id: string = '';

    public updateCertificate: {
        existingLot: boolean;
        auctionName: string;
        salesDate: string;
        releaseDate: string;
        firstName: string;
        lastName: string;
        lotImageSrc: string;
        lotImage: any;
        lotName: string;
        lotTechnical: string;
        lotSize: string;
        lotTechnicalDetails: string;
    } = {
        existingLot: true,
        auctionName: '',
        salesDate: '',
        releaseDate: '',
        firstName: '',
        lastName: '',
        lotImageSrc: '',
        lotImage: '',
        lotName: '',
        lotTechnical: '',
        lotSize: '',
        lotTechnicalDetails: ''
    };

    public addBtnLoading: boolean = false;
    public updateCertificateSuccess: string = '';
    public updateCertificateError: string = '';

    constructor() {
        super();
    }

    mounted() {
        this.id = this.$root.$route.params.id;
        this.getCertificate();
    }

    async getCertificate() {
        await fetch(`${process.env.API2_URL}/certificate/${this.id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                if (data.data.lot !== undefined) {
                    this.updateCertificate.existingLot = true;
                    this.updateCertificate.auctionName = data.data.auction.name;
                    this.updateCertificate.lotName = data.data.lot.name;
                } else {
                    this.updateCertificate.existingLot = false;
                    this.updateCertificate.lotImageSrc = data.data.lotData.image;
                    this.updateCertificate.lotName = data.data.lotData.name;
                    this.updateCertificate.lotTechnical = data.data.lotData.technical;
                    this.updateCertificate.lotTechnicalDetails = data.data.lotData.technical_details;
                    this.updateCertificate.lotSize = data.data.lotData.size
                }

                this.updateCertificate.salesDate = moment(data.data.salesDate).format('DD-MM-YYYY');
                this.updateCertificate.releaseDate = moment(data.data.releaseDate).format('DD-MM-YYYY');
                this.updateCertificate.firstName = data.data.firstName;
                this.updateCertificate.lastName = data.data.lastName;
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    async updateCertificateAction() {
        let payload = {};
        let lotImage: any = '';

        if (this.updateCertificate.existingLot) {
            if (!this.updateCertificate.firstName || !this.updateCertificate.lastName || !this.updateCertificate.salesDate || !this.updateCertificate.releaseDate) {
                alert('Te rugam sa completezi toate datele din formular');
                return;
            }

            payload = {
                'existing_lot': true,
                'first_name': this.updateCertificate.firstName,
                'last_name': this.updateCertificate.lastName,
                'sales_date': this.updateCertificate.salesDate,
                'release_date': this.updateCertificate.releaseDate
            }
        } else {
            if (!this.updateCertificate.lotName || !this.updateCertificate.lotTechnical || !this.updateCertificate.lotSize || !this.updateCertificate.lotTechnicalDetails || !this.updateCertificate.firstName || !this.updateCertificate.lastName || !this.updateCertificate.salesDate || !this.updateCertificate.releaseDate) {
                alert('Te rugam sa completezi toate datele din formular');
                return;
            }

            if (this.updateCertificate.lotImage) {
                lotImage = await this.convertToBase64(this.updateCertificate.lotImage);
            }

            payload = {
                'existing_lot': false,
                'first_name': this.updateCertificate.firstName,
                'last_name': this.updateCertificate.lastName,
                'sales_date': this.updateCertificate.salesDate,
                'release_date': this.updateCertificate.releaseDate,
                'lot_image': lotImage,
                'lot': {
                    'name': this.updateCertificate.lotName,
                    'technical': this.updateCertificate.lotTechnical,
                    'size': this.updateCertificate.lotSize,
                    'technical_details': this.updateCertificate.lotTechnicalDetails,
                }
            }
        }

        this.addBtnLoading = true;

        await fetch(`${process.env.API2_URL}/certificate/${this.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
                this.updateCertificateError = `Eroare: ${response.status}`;
                this.updateCertificateSuccess = '';
            }

            this.addBtnLoading = false;

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.updateCertificateSuccess = data.message;
                this.updateCertificateError = '';
            } else {
                this.updateCertificateError = data.message;
                this.updateCertificateSuccess = '';
            }

            this.addBtnLoading = false;
        }).catch(error => {
            console.error('Error:', error);
            this.updateCertificateError = error;
            this.updateCertificateSuccess = '';
            this.addBtnLoading = false;
        });
    }

    convertToBase64(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                if (!e.target) {
                    reject(new Error('No target'));
                    return;
                }

                resolve(e.target.result);
            };

            reader.onerror = error => {
                reject(error);
            };

            reader.readAsDataURL(image);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/certificates/manage/index.ts